import { render } from "./SkuVxeTable.vue?vue&type=template&id=52b87594&scoped=true"
import script from "./SkuVxeTable.vue?vue&type=script&lang=js"
export * from "./SkuVxeTable.vue?vue&type=script&lang=js"

import "./SkuVxeTable.vue?vue&type=style&index=0&id=52b87594&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b87594"]])

export default __exports__